import React from "react";

import TextInput from "@krea/customer-features/shared-components/fields/input";

import InputLinkPreview from "./InputLinkPreview";

const InputLink = ({ isPreviewMode, value, classNamePreview, ...rest }) => {
  return isPreviewMode ? (
    <InputLinkPreview value={value} className={classNamePreview} />
  ) : (
    <TextInput type="url" autoComplete="off" value={value} {...rest} />
  );
};

export default InputLink;
